import type { StreamActivity } from "@/features/study-group-stream/types/streamActivity";

export const activityKey = (activity: StreamActivity) =>
  `${activity.type}:${activity.id}`;

export const sortStreamActivities = (activities: StreamActivity[]) =>
  [...activities].sort((left, right) => {
    const timestampDelta =
      Date.parse(right.createdAt) - Date.parse(left.createdAt);
    return timestampDelta || right.id - left.id;
  });

export const mergeStreamActivities = (
  current: StreamActivity[],
  incoming: StreamActivity[],
) => {
  const byKey = new Map(current.map((item) => [activityKey(item), item]));
  for (const item of incoming) {
    byKey.set(activityKey(item), item);
  }
  return sortStreamActivities([...byKey.values()]);
};
